import React from 'react'
import { withIcon } from '../../withIcon'

function CaretLeftOutlineIcon (props) {
  const {
    size = '24px',
    color = 'currentColor',
  } = props

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M7.44702 12.4562C7.19507 12.2042 7.19507 11.7958 7.44702 11.5438L13.6406 5.35026C13.8251 5.16575 14.1026 5.11055 14.3437 5.21041C14.5847 5.31027 14.7419 5.54552 14.7419 5.80646L14.7419 18.1935C14.7419 18.4545 14.5847 18.6897 14.3437 18.7896C14.1026 18.8894 13.8251 18.8342 13.6406 18.6497L7.44702 12.4562ZM13.4516 16.636L13.4516 7.36401L8.81561 12L13.4516 16.636Z" fill={color}/>
    </svg>
  )
}

export default withIcon(CaretLeftOutlineIcon)
